import { LinkButton } from '@finn-no/troika-react-buttons';
import type { ChangeEvent, FocusEvent, KeyboardEvent, MouseEvent } from 'react';
import { useRef } from 'react';

export interface LinkButtonTextFieldProps {
    id: string;
    label: string;
    type?: string;
    value: string;
    metric?: string;
    prefix?: string;
    showInput: boolean;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
    onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
    onKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void;
    floatRight?: boolean;
    min?: number;
    max?: number;
}

export const LinkButtonTextField = ({
    id,
    label,
    type = 'string',
    value,
    metric = '',
    prefix = '',
    showInput,
    onClick,
    onChange,
    onBlur,
    onFocus,
    onKeyPress,
    floatRight,
}: LinkButtonTextFieldProps) => {
    const shouldFocus = useRef(false);

    const focusIfClicked = (element: HTMLInputElement): void => {
        if (shouldFocus.current) {
            element.focus();
            shouldFocus.current = false;
        }
    };

    return (
        (showInput && (
            <div className="input input--no-bottom-margin input--number">
                <label className="label" htmlFor={id}>
                    {label}
                </label>
                <input
                    id={id}
                    type={type}
                    data-testid={`LinkButtonTextField-input-${id}`}
                    value={value}
                    onChange={onChange}
                    onFocus={(event: FocusEvent<HTMLInputElement>): void => {
                        if (onFocus) onFocus(event);
                        event.target.select();
                    }}
                    onBlur={onBlur}
                    onKeyPress={onKeyPress}
                    ref={focusIfClicked}
                />
            </div>
        )) || (
            <LinkButton
                className={floatRight ? 'u-float-right' : ''}
                data-testid={`LinkButtonTextField-button-${id}`}
                onClick={(event: MouseEvent<HTMLButtonElement>): void => {
                    if (onClick) onClick(event);
                    shouldFocus.current = true;
                }}>
                {prefix} {value} {metric}
            </LinkButton>
        )
    );
};
